import { render, staticRenderFns } from "./care.vue?vue&type=template&id=c060f746&scoped=true&"
import script from "./care.vue?vue&type=script&lang=js&"
export * from "./care.vue?vue&type=script&lang=js&"
import style0 from "./care.vue?vue&type=style&index=0&id=c060f746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c060f746",
  null
  
)

export default component.exports